<template>
<div>

<ContentHeader :title="$store.state.languages.lang_phrases.soru_listesi_bilgileri"  :show_button="false" ></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>




<template v-if="!loading">
<div class="mt-4">

<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="item.name" valkey="name" @dataChanged="dataChanged" />

<ClickEditSwitch  :title="$store.state.languages.lang_phrases.puanlama_aktif" :value="item.calculate_points" valkey="calculate_points" @dataChanged="dataChanged" />


<ClickEditSwitch  v-if="item.calculate_points" :title="$store.state.languages.lang_phrases.bolum_puani_hesaplama" :value="item.dont_calculate_section_points" valkey="dont_calculate_section_points" @dataChanged="dataChanged" />
<ClickEditSwitch  v-if="item.calculate_points" title="Soru puanları üst puan limitinden düşülür" :value="item.calculate_by_substraction" valkey="calculate_by_substraction" @dataChanged="dataChanged" />
<ClickEditNumber v-if="item.calculate_points" :title="$store.state.languages.lang_phrases.ust_puan_limiti" :value="item.limitscore" valkey="limitscore" @dataChanged="dataChanged"  :steps=".1" />
<ClickEditNumber v-if="item.calculate_points" :title="$store.state.languages.lang_phrases.hesaplama_boleni" :value="item.pointsdivider" valkey="pointsdivider" @dataChanged="dataChanged"  :steps=".1" />
<ClickEditSwitch  title="Sadece Yüzde Göster" :value="item.only_percentage" valkey="only_percentage" @dataChanged="dataChanged" />
<ClickEditSelect :title="$store.state.languages.lang_phrases.soru_listesi_modeli" :value="item.type" :options="questionlist_types" valkey="type" @dataChanged="dataChanged"  />

<ClickEditSwitch  title="Çoklu Hesaplama" :value="item.multiple_calculations" valkey="multiple_calculations" @dataChanged="dataChanged" />


</div>
</template>
</div>



</template>

<script>
export default {

  name: 'FlowGeneral',

  data () {
    return {
    	item:null,
    	loading:true,      
      questionlist_types:[
        {name:"Çeşitli Soru Modeli",id:"various_questions"},
        {name:"Aynı Soru Modeli ",id:"same_question_pattern"},
      ],
    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"genel") 
  	this.getData()
  },
  methods:{
  	async getData()
    {
        this.item = await this.generalApiGetWithoutLoader("questionlist/"+this.$route.params.id)
        let sections = await this.generalApiGetWithoutLoader("questionlist_sections/"+this.$route.params.id)
        let inputfields = await this.generalApiGetWithoutLoader("questionlist_inputfields/"+this.$route.params.id)
        await this.$store.dispatch('questionlists/setInputfields',inputfields)
        await this.$store.dispatch('questionlists/setSections',sections) 
        console.log(this.item)

        this.loading = await false
    },
    dataChanged(data)
    {
    	console.log(data.value)
    	console.log(data.key)
    	let formdata = new FormData()
    	formdata.append(data.key,data.value)
    	this.generalSubmission(formdata,"questionlists/update/"+this.item.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
    	console.log("data changed");
    	console.log(response);
      this.item = response.data
      this.$store.dispatch('questionlists/setQuestionlist',response.data) 
    	
    	
    }
  }
};
</script>

<style lang="css" scoped>
</style>